import { takeLatest, call, put } from 'redux-saga/effects';
import { ActionType, getType } from 'typesafe-actions';
import { saveAs } from 'file-saver';
import { dashboardService } from '../services';
import { bwicLogActions } from '../actions/bwic-log.actions';


function* watchBwicLogExport(action: ActionType<typeof bwicLogActions.bwicLogExportDataRequest>) {
    try {
        const { securityId } = action.payload;
        const { blob, name } = yield call(dashboardService.exportBwicStatistic, securityId);
        saveAs(blob, name);
        yield put(bwicLogActions.bwicLogExportDataSuccess())
    } catch (e) {
        yield put(bwicLogActions.bwicLogExportDataFailure(e))
    }
}

export function* watchBwicLog() {
    yield takeLatest(getType(bwicLogActions.bwicLogExportDataRequest), watchBwicLogExport);
}
